exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".message[data-v-3deb7877] {\n  padding: 1em 0 2em;\n}\n.choice[data-v-3deb7877] {\n  position: relative;\n  padding-left: 2em;\n  padding-bottom: 2em;\n}\n.choice .mr-radio[data-v-3deb7877] {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n", ""]);

// exports
